// --- Dependencies -------------------------------------------------------------------------------
import { MenuItem, Select } from "@mui/material";
import type { SelectChangeEvent } from "@mui/material/Select";
// --- Our Modules --------------------------------------------------------------------------------
import "./styles.css";

// --- Types --------------------------------------------------------------------------------------

type TyOption = { value: string; label: string };

type Props = {
    value: string;
    onChange: (value: string) => void;
    options: TyOption[];
    /** The label for "not narrowed by this at all", which is always the first row. */
    anyLabel: string;
};

// --- Logic --------------------------------------------------------------------------------------

/**
 * One narrowing choice inside the actions bar's filter mode.
 *
 * The same MUI picker the forms use, sized down to sit in a 36px row: a filter is still a field, and
 * a native select would be the one control in the app that opens the system's own list.
 */
export default function FilterSelectInput({ value, onChange, options, anyLabel }: Props) {
    const handleChange = (event: SelectChangeEvent) => onChange(event.target.value);

    return (
        <Select
            className="filter-select"
            data-on={!!value}
            value={value}
            onChange={handleChange}
            displayEmpty
            size="small"
            MenuProps={{ slotProps: { paper: { className: "filter-select-paper" } } }}
        >
            <MenuItem value="">{anyLabel}</MenuItem>
            {options.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                    {option.label}
                </MenuItem>
            ))}
        </Select>
    );
}
